module.exports = __webpack_public_path__ + "img/info-circle-icon.01800c8e.svg";